// ─────────────────────────────────────────────────────────────────────────────
// SplitComissoes.jsx — Página "Split de Comissões" (/split-comissoes)
// Reaproveita o template rico das funcionalidades (FuncionalidadeDetalhe) com o
// conteúdo do item "split-comissoes" em src/data/features.js. SEO (title,
// description, keywords) e FAQ foram mantidos da versão anterior; o canonical
// continua em /split-comissoes.
// ─────────────────────────────────────────────────────────────────────────────
import FuncionalidadeDetalhe from "./FuncionalidadeDetalhe";

export default function SplitComissoes() {
  return <FuncionalidadeDetalhe slug="split-comissoes" path="/split-comissoes" />;
}
